import * as d3 from 'd3'
export default {
  methods: {

    verifyErrors() {
      let verify = false
      let message = []

      let msgGroup = this.svg
      .append('g')
      .attr('transform', `translate(20.5, 20.5)`)

      this.header.titles.forEach(d=> {
        if(this.header.titles[0].length != d.length) {
          message.push({
            error: 'ValueError:',
            msg: `[header.title] length (${d.length}) does not match expected length (${this.header.titles[0].length}).`
          })
        }
      })

      if(this.groups.columns.length + this.values.columns.length != this.header.titles[0].length){
        message.push({
          error: 'Verify Array Lengths:',
          msg: `Ensure that the [header.title](${this.header.titles[0].length}) and [groups.columns]+[values.columns](${this.groups.columns.length + this.values.columns.length}) have the same length.`
        })
      }

      if(this.groups.subTotal.visible == 'Y'  && this.groups.subTotal.opacity.length != this.groups.columns.length) {
         message.push({
          error: 'Verify Array Lengths:',
          msg: `Ensure that the [groups.subTotal.opacity](${this.groups.subTotal.opacity.length}) and [groups.columns](${this.groups.columns.length}) have the same length.`
        })
      }

       if(this.header.depths.length != this.header.titles.length) {
         message.push({
          error: 'Verify Array Lengths:',
          msg: `Ensure that the [header.depths](${this.header.depths.length}) and [header.titles](${this.header.titles.length}) have the same length.`
        })
      }


      if(message.length > 0) {
        verify = true

        msgGroup
        .append('rect')
        .attr('id', 'ERROR_BOX')
        .attr('x', 0).attr('y', 0).attr('rx', 5)
        .attr('width', 550).attr('height', 150).attr('stroke', '#757575').attr('stroke-width', .5)
        .attr('fill', '#F4F5F5').attr('opacity', .5)

        msgGroup
        .append('path')
        .attr('transform', `translate(20, 10)`).attr('fill', '#F35E90')
        .attr('d', `M33.6,24.6l-13.8-23c-0.9-1.5-2.9-2-4.5-1.1c-0.4,0.3-0.8,0.6-1.1,1.1h0l-13.8,23c-0.9,1.6-0.4,3.6,1.2,4.5 c0.5,0.3,1,0.4,1.6,0.4h27.6c1.8,0,3.2-1.5,3.2-3.3C34,25.6,33.9,25.1,33.6,24.6z M17,25.7c-1,0-1.9-0.8-1.9-1.9 c0-1,0.8-1.9,1.9-1.9c0,0,0,0,0,0c1,0,1.9,0.8,1.9,1.9C18.9,24.8,18.1,25.7,17,25.7z M18.2,20.4C18.2,20.4,18.2,20.5,18.2,20.4 c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2l-1-11.5c0-1.2,1-2.2,2.2-2.2c1.2,0,2.2,1,2.2,2.2L18.2,20.4z`)
        
        msgGroup
        .append('text')
        .attr('x', 75).attr('y', 33).attr('font-size', 25).attr('fill', '#F35E90')
        .text('Concentrate!')

        let y_ = 35
        message.forEach(d=> {
          let errors = msgGroup
          .append('g')
          .attr('transform', `translate(20, ${y_})`)

          errors
          .append('text')
          .attr('x', 0).attr('y', y_).attr('font-size', 14).attr('fill', '#44A9DF')
          .text(d.error)

          errors
          .append('text')
          .attr('x', 0).attr('y', y_ + 20).attr('font-size', 12).attr('fill', '#333')
          .text(d.msg)

          y_ = y_ + 30
        })
        d3.select('#ERROR_BOX').attr('height', message.length*60 + 50)

      } else verify = false
      
      return verify
    },

  }
}